import { Currency, PermissionEnum } from '@ui/src';
import { ApplicationType } from '../../hoc/new-application/types';

export enum ClientRangeTypeEnum {
  MONTHLY_TURNOVER = 'MONTHLY_TURNOVER',
  MONTHLY_NUMBER_OF_INCOMING_TRANSACTIONS = 'MONTHLY_NUMBER_OF_INCOMING_TRANSACTIONS',
  MONTHLY_NUMBER_OF_OUTGOING_TRANSACTIONS = 'MONTHLY_NUMBER_OF_OUTGOING_TRANSACTIONS',
  MONTHLY_VALUE_OF_INCOMING_TRANSACTIONS = 'MONTHLY_VALUE_OF_INCOMING_TRANSACTIONS',
  MONTHLY_VALUE_OF_OUTGOING_TRANSACTIONS = 'MONTHLY_VALUE_OF_OUTGOING_TRANSACTIONS',
  MONTHLY_MAX_VALUE_OF_INCOMING_PAYMENT = 'MONTHLY_MAX_VALUE_OF_INCOMING_PAYMENT',
  MONTHLY_MAX_VALUE_OF_OUTGOING_PAYMENT = 'MONTHLY_MAX_VALUE_OF_OUTGOING_PAYMENT',
}

export interface ClientRange {
  clientType: ApplicationType;
  type: ClientRangeTypeEnum;
  from: number;
  id: string;
}

export interface RiskScoreItem {
  riskScoreRange: {
    name: string;
    rangeStart: number;
    rangeEnd: number;
    action: string;
    id: string;
  };
  name: string;
  fromYear?: number;
  riskScoreRangeId: string;
  riskScore: number;
  id: string;
}

export interface SicCode {
  description: string;
  code: string;
  riskScore: number;
  id: string;
}

export interface Employee {
  id: string;
  profile: {
    firstName: string;
    lastName: string;
  };
  permissions?: PermissionEnum[];
  employeePermissions: {
    permissions: PermissionEnum[];
  }[];
  status: string;
}

export interface PaymentType {
  createdAt: string;
  enabled: boolean;
  id: string;
  name: string;
  paymentType: string;
  visibleToClients: boolean;
  currencies: {
    edges: {
      node: Currency;
    }[];
  };
}
